import React from 'react';

interface PlusIconProps extends React.SVGProps<SVGSVGElement> {
	width?: number;
	height?: number;
	fill?: string;
}

export function PlusIcon({ width = 16, height = 16, fill = 'currentColor', ...props }: Readonly<PlusIconProps>) {
	return (
		<svg {...props} fill="none" width={width} height={height} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M8 2C8.55214 2.00018 9 2.44782 9 3V7H12.9993C13.5516 7 14 7.44772 14 8C14 8.55218 13.5521 8.99982 13 9H9V13C9 13.5522 8.55214 13.9998 8 14C7.44772 14 7 13.5523 7 13V9H3C2.44772 9 2 8.55229 2 8C2 7.44782 2.44721 7.00018 2.99935 7H7V3C7 2.44772 7.44772 2 8 2Z"
				fill={fill}
			/>
		</svg>
	);
}
